import React from "react";
import BaseComponent from "../baseComponent";
import UsersComponent from "./usersComponent";
import Utility, {dispatchAction} from "../../utility";
import {connect} from "react-redux";
import {eventConstants} from "../../constants";
import userService from "../../services/user";

export class Users extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {usersList: []};
    }

    componentDidMount() {
        this.refreshList().then("")
    }

    refreshList = async () => {
        this.props.dispatchAction(eventConstants.SHOW_LOADER);
        let [err, res] = await Utility.parseResponse(userService.getUserList(),);
        this.props.dispatchAction(eventConstants.HIDE_LOADER);
        if (!res || err)
            return Utility.apiFailureToast("Unable to fetch users");
        res.users.sort((a, b) => new Date(b.modifiedOn).getTime() - new Date(a.modifiedOn).getTime());
        this.setState({usersList: res.users || []})
    }


    render() {
        return (
            <UsersComponent
                state={this.state}
                refreshList={this.refreshList}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user};
};

export default connect(mapStateToProps, {dispatchAction})(Users);
